// Externals
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
// Actions
import { redirectToSearch } from '../../actions/collection';

// Contants
import { withCurrency } from '../currency';

// Components
import { LandingPage as LandingPageComponent } from '@homeexchange/landing-page';

const LandingPage = (props) => {
    const { currency, localeDescription, accessToken, refreshToken } = props;

    return (
        <LandingPageComponent
            config={{
                apiUrl: process.env.URL_BFF,
                assetsUrl: process.env.URL_MIGRATION_ASSETS,
                locale: localeDescription,
                currency: currency,
                tokens: {
                    accessToken,
                    refreshToken
                }
            }}
        />
    );
};

LandingPage.propTypes = {
    accessToken: PropTypes.string,
    refreshToken: PropTypes.string,
    localeDescription: PropTypes.string,
    currency: PropTypes.string
};

const mapStateToProps = (state) => ({
    accessToken: state.auth.accessToken,
    refreshToken: state.auth.refreshToken,
    localeDescription: state.localeDescription,
    currency: state.currency
});

const mapDispatchToProps = (dispatch) => ({
    redirectToSearch: bindActionCreators(redirectToSearch, dispatch)
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withCurrency)(LandingPage);
